import { Link } from 'react-router-dom';

import type { InstantSurveyType } from '@api/instant_survey/types';
import { Card, getSurveyIcon } from '@utilities';

import styles from './_index.module.scss';

interface SurveyCardProps {
  isModalTrigger: boolean;
  onSelect: (surveyType: InstantSurveyType) => void;
  size: SurveyCardSize;
  surveyType: InstantSurveyType;
}

type SurveyCardSize = 'large' | 'medium';

const SurveyCard = ({ isModalTrigger, onSelect, size, surveyType }: SurveyCardProps) => {
  const isLarge = size === 'large';
  const className = isLarge ? styles['survey-card-large'] : styles['survey-card-medium'];
  const iconClassName = isLarge
    ? styles['survey-card-icon-large']
    : styles['survey-card-icon-medium'];

  const icon = (
    <span aria-hidden="true" className={iconClassName}>
      {getSurveyIcon(surveyType.id)}
    </span>
  );
  const content = isLarge ? (
    <>
      {icon}
      <h2>{surveyType.name}</h2>
      <p>{surveyType.description}</p>
    </>
  ) : (
    <>
      {icon}
      <span className={styles['survey-card-medium-content']}>
        <span className={styles['survey-card-medium-use-case']}>{surveyType.useCase}</span>
        <span className={styles['survey-card-medium-name']}>{surveyType.name}</span>
      </span>
    </>
  );

  if (isModalTrigger) {
    return (
      <Card
        aria-label={`Create ${surveyType.name}`}
        as="button"
        className={className}
        elevation={1}
        onClick={() => onSelect(surveyType)}
        type="button"
      >
        {content}
      </Card>
    );
  }

  return (
    <Card
      as={Link}
      className={className}
      data-log="InstantSurvey_Open"
      data-log-properties={JSON.stringify({ type: surveyType.id })}
      elevation={1}
      to={`/dashboard/create-survey/${surveyType.id}`}
    >
      {content}
    </Card>
  );
};

export default SurveyCard;
